import React, { useEffect, useState } from 'react';
import { Trash2, Loader2, Download } from 'lucide-react';
import { adminGetNewsletter, adminDeleteNewsletter } from '../../lib/api';

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); adminGetNewsletter().then(setItems).finally(() => setLoading(false)); };
  useEffect(load, []);
  const remove = async (id) => { if (confirm('¿Borrar?')) { await adminDeleteNewsletter(id); load(); } };
  const exportCSV = () => {
    const rows = [['Fecha', 'Email']];
    items.forEach((i) => rows.push([i.created_at, i.email]));
    const csv = rows.map((r) => r.map((c) => `"${(c || '').toString().replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' }); const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = `newsletter-${Date.now()}.csv`; a.click();
  };
  return (
    <div className="p-6 md:p-10">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif-display text-3xl text-white mb-1">Newsletter</h1><p className="text-white/55">{items.length} suscriptores</p></div>
        <button onClick={exportCSV} className="gd-btn-ghost px-4 py-2 text-[11px] uppercase tracking-widest inline-flex items-center gap-2"><Download size={13} /> Exportar CSV</button>
      </div>
      {loading ? <Loader2 className="animate-spin text-[#c9a063]" /> : (
        <div className="gd-card overflow-hidden">
          <table className="w-full">
            <thead><tr className="border-b border-white/10 text-[10px] uppercase tracking-widest text-white/50"><th className="text-left px-5 py-3">Email</th><th className="text-left px-5 py-3">Fecha</th><th className="px-5 py-3 w-16"></th></tr></thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-5 py-3 text-white">{i.email}</td>
                  <td className="px-5 py-3 text-white/55 text-sm">{new Date(i.created_at).toLocaleDateString('es-ES')}</td>
                  <td className="px-5 py-3"><button onClick={() => remove(i.id)} className="text-white/40 hover:text-red-400"><Trash2 size={14} /></button></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan="3" className="text-center py-12 text-white/40">No hay suscriptores todavía</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
